export default __webpack_public_path__ + "static/media/archive-session-ok.dea665a2.svg";